
const BASE_URL = '';  // for Production, use relative
//const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
export const API_BASE = BASE_URL + '/api';

/**
 * Helper function to ensure an absolute URL for use with URL constructor.
 * If API_BASE is relative (starts with /), it will be converted to an absolute URL
 * using the current window origin.
 */
export function getAbsoluteApiUrl(path: string): string {
  const fullPath = `${API_BASE}${path}`;
  // If it's already an absolute URL (starts with http:// or https://), return as is
  if (fullPath.startsWith('http://') || fullPath.startsWith('https://')) {
    return fullPath;
  }
  // Otherwise, prepend window.location.origin to make it absolute
  return `${window.location.origin}${fullPath}`;
}
